import React from "react";
import { TableCell, Typography, Grid } from "@material-ui/core";
import { observer, inject } from "mobx-react";
import { Location } from "@src/Interfaces/Entity/Location";
import { IValuesStore } from "Stores/Values/types";
import { computed } from "mobx";
import EntityDelete from "@src/Components/Common/EntityDelete/EntityDelete";
import RestoreIcon from "@material-ui/icons/Restore";
import { IManagementStore } from "@src/Stores/Management/types";
import DirectionsBoat from "@material-ui/icons/DirectionsBoat";
import LocationCity from "@material-ui/icons/LocationCity";
import LocalShipping from "@material-ui/icons/LocalShipping";
import PinDrop from "@material-ui/icons/PinDrop";
import { Values } from "@src/Tools/Values";
import { STIconWrapper } from "@src/Components/Common/FormFields/FormSimpleSelect/styles";
import { STTableRow } from "@src/Components/Ui/STTableRow";
import _ from "lodash";
import { IAuthStore } from "@src/Stores/Auth/types";
import { STTableCellTypography } from "@src/Components/Ui/STTableCellTypography";
import CreateIcon from "@material-ui/icons/Create";
import RoundButton from "@src/Shared/Components/RoundButton/RoundButton";

interface IProps {
  location: Location;
  auth?: IAuthStore;
  values?: IValuesStore;
  management?: IManagementStore;
  onEditButtonClick?: (location: Location) => void;
}

@inject("auth", "values", "management")
@observer
class LocationTableItem extends React.Component<IProps> {
  @computed get isActive() {
    return this.props.location.state === this.props.values.states.Active;
  }

  @computed get noPositions() {
    var positionIds = (this.props.location.locationPositions || []).map(position => position.positionId);
    return (
      positionIds.length === 0 || !_.some(this.props.management.activePositions, ap => _.includes(positionIds, ap.id))
    );
  }

  getIcon = () => {
    const [locKey, locValue]: [string, number] = Object.entries(this.props.values.locationTypes).find(
      ([key, value]: [string, number]) => value === this.props.location.type
    );
    switch (this.props.values.locationTypes[locKey]) {
      case this.props.values.locationTypes.Office:
        return (
          <React.Fragment>
            <STIconWrapper>
              <LocationCity nativeColor="rgba(0, 0, 0, 0.54)" />
            </STIconWrapper>
            <STTableCellTypography>{Values.getLocalizationValue(locKey)}</STTableCellTypography>
          </React.Fragment>
        );
      case this.props.values.locationTypes.Vessel:
        return (
          <React.Fragment>
            <STIconWrapper>
              <DirectionsBoat nativeColor="rgba(0, 0, 0, 0.54)" />
            </STIconWrapper>
            <STTableCellTypography>{Values.getLocalizationValue(locKey)}</STTableCellTypography>
          </React.Fragment>
        );
      case this.props.values.locationTypes.Truck:
        return (
          <React.Fragment>
            <STIconWrapper>
              <LocalShipping nativeColor="rgba(0, 0, 0, 0.54)" />
            </STIconWrapper>
            <STTableCellTypography>{Values.getLocalizationValue(locKey)}</STTableCellTypography>
          </React.Fragment>
        );
      default:
        return (
          <React.Fragment>
            <STIconWrapper>
              <PinDrop nativeColor="rgba(0, 0, 0, 0.54)" />
            </STIconWrapper>
            <STTableCellTypography>{Values.getLocalizationValue(locKey)}</STTableCellTypography>
          </React.Fragment>
        );
    }
  };

  handleRemove = async () => {
    this.props.location.state = this.props.values.states.Removed;
    await this.props.management.removeLocation(this.props.location);
  };

  handleRestore = async () => {
    await this.props.management.restoreDeletedLocation(this.props.location.id);
  };

  @computed get canDeleteLocation() {
    const { location, auth } = this.props;
    return (
      auth.user.location.id !== location.id &&
      !location.primary &&
      auth.user.roles.find(x => x == this.props.values.roles.Administrator) != null &&
      !this.isActive
    );
  }

  render() {
    const { location } = this.props;
    return (
      <STTableRow hover isActive={this.isActive}>
        <TableCell component="th" scope="row" size="small">
          <Typography>
            <STTableCellTypography>{location.name}</STTableCellTypography>
          </Typography>
        </TableCell>
        <TableCell size="small">
          <STTableCellTypography>{location.description}</STTableCellTypography>
        </TableCell>
        <TableCell align="center" size="small">
          <Grid container alignItems="center">
            {this.getIcon()}
          </Grid>
        </TableCell>
        <TableCell component="th" scope="row" size="small">
          <STTableCellTypography>
            {this.noPositions && Values.getLocalizationValue("noPositionsAssigned")}
          </STTableCellTypography>
        </TableCell>
        <TableCell align="right" size="small">
          <Grid container wrap="nowrap" justify="flex-end">
            {location.state === this.props.values.states.Removed && this.props.auth.user.location.primary && (
                <RoundButton
                icon={<RestoreIcon/>}
                tooltipTitle={Values.getLocalizationValue("restore")}
                onClick={() => this.handleRestore()}
                />
            )}
            {location.state !== this.props.values.states.Removed &&
              (this.props.auth.user.location.primary || this.props.auth.user.location.id === location.id) && (
                    <RoundButton
                        icon={<CreateIcon/>}
                        tooltipTitle={Values.getLocalizationValue("edit")}
                        onClick={() => this.props.onEditButtonClick(location)}
                    />
              )}
            {location.state !== this.props.values.states.Removed && this.props.auth.user.location.primary && (
              <div
                style={{
                  visibility: this.canDeleteLocation ? "visible" : "hidden",
                }}
              >
                <EntityDelete onSubmit={this.handleRemove} />
              </div>
            )}
          </Grid>
        </TableCell>
      </STTableRow>
    );
  }
}

export default LocationTableItem;
